/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SelettivaUpdatePartecipazioneDto } from '../../models/selettiva-update-partecipazione-dto';

export interface ApiSelettivaSelettivaUpdatePartecipazionePost$Params {
    /**
     * id della selettiva da caricare
     */
    body: SelettivaUpdatePartecipazioneDto;
}

export function apiSelettivaSelettivaUpdatePartecipazionePost(
    http: HttpClient,
    rootUrl: string,
    params: ApiSelettivaSelettivaUpdatePartecipazionePost$Params,
    context?: HttpContext,
): Observable<StrictHttpResponse<boolean>> {
    const rb = new RequestBuilder(rootUrl, apiSelettivaSelettivaUpdatePartecipazionePost.PATH, 'post');
    if (params) {
        rb.body(params.body, 'application/json');
    }

    return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
            return (r as HttpResponse<any>).clone({
                body: String((r as HttpResponse<any>).body) === 'true',
            }) as StrictHttpResponse<boolean>;
        }),
    );
}

apiSelettivaSelettivaUpdatePartecipazionePost.PATH = '/api/selettiva/selettiva-update-partecipazione';
